import useMyInfo from '@api/hooks/auth/useMyInfo';
import {
  getIsSubscribedToOffline,
  getIsSubscribedToPlus
} from '@api/selectors/subscription';

const useSubscribed = (goalUID = '') => {
  const isPlusSubscribed = useMyInfo(getIsSubscribedToPlus(goalUID));
  const isOfflineSubscribed = useMyInfo(getIsSubscribedToOffline(goalUID));
  return isPlusSubscribed || isOfflineSubscribed;
};
export default useSubscribed;
